/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_SaveInputs */

const cs_pm_save = /** @type {(inputs: Pm_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit ID inzerátů`)
};

const en_pm_save = /** @type {(inputs: Pm_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save listing IDs`)
};

/**
* | output |
* | --- |
* | "Save listing IDs" |
*
* @param {Pm_SaveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_save = /** @type {((inputs?: Pm_SaveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_SaveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_save(inputs)
	return cs_pm_save(inputs)
});